import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
const datepickerContextDefaultValue = {
  rtl: !1,
  focusedDate: null,
  isDateFocused: () => !1,
  isDateSelected: () => !1,
  isDateHovered: () => !1,
  isDateBlocked: () => !1,
  isFirstOrLastSelectedDate: () => !1,
  onDateFocus: () => {
  },
  onDateHover: () => {
  },
  onDateSelect: () => {
  },
  onDayRender: void 0,
  goToPreviousMonthsByOneMonth: () => {
  },
  goToPreviousMonths: () => {
  },
  goToNextMonthsByOneMonth: () => {
  },
  goToNextMonths: () => {
  },
  goToPreviousYear: () => {
  },
  goToNextYear: () => {
  }
}, DatepickerContext = createContext(datepickerContextDefaultValue), LmDatepickerProvider = ({ children, ...value }) => /* @__PURE__ */ jsx(DatepickerContext.Provider, { value, children }), useDatepickerContext = () => useContext(DatepickerContext);
export {
  LmDatepickerProvider,
  datepickerContextDefaultValue,
  useDatepickerContext
};
//# sourceMappingURL=DatepickerProvider.js.map
